import actions from './constants';

export const newRequestSuccess = (category, code, result, previousUrl) => ({
  type: actions.NEW_REQUEST_SUCCESS, category, code, result, previousUrl,
});

export const newRequestError = (category, code, error) => ({
  type: actions.NEW_REQUEST_ERROR,
  category,
  code,
  error,
});

export const updateRequestProperties = (category, code, properties) => ({
  type: actions.UPDATE_REQUEST_PROPERTIES,
  category,
  code,
  properties,
});

export const updateRequestTransferType = (category, code, transferType) => ({
  type: actions.UPDATE_REQUEST_TRANSFER_TYPE,
  category,
  code,
  transferType,
});

export const updateRequestSource = (category, code, source) => ({
  type: actions.UPDATE_REQUEST_SOURCE,
  category,
  code,
  source,
});

export const fetchRequests = (category, page, pageSize, append) => ({
  type: actions.FETCH_REQUESTS,
  category,
  page,
  pageSize,
  append,
});

export const showRequestsResults = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_REQUESTS_RESULTS,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showRequestsError = (category, error) => ({
  type: actions.SHOW_REQUESTS_ERROR,
  category,
  error,
});

export const toggleRequestSelected = (category, code) => ({
  type: actions.TOGGLE_REQUEST_SELECTED,
  category,
  code,
});

export const showApproveRequest = (category, code, action) => ({
  type: actions.SHOW_APPROVE_REQUEST,
  category,
  code,
  action,
});

export const hideApproveRequest = () => ({
  type: actions.HIDE_APPROVE_REQUEST,
});

export const requestPollingComplete = (category, code) => ({
  type: actions.MARK_POLLING_COMPLETE,
  category,
  code,
});

export const showCloneRequest = (category, code, result) => ({
  type: actions.SHOW_CLONE_REQUEST,
  category,
  code,
  result,
});

export const showRequest = (category, code, result) => ({
  type: actions.SHOW_REQUEST,
  category,
  code,
  result,
});

export const showRequestError = (category, code, error) => ({
  type: actions.SHOW_REQUEST_ERROR,
  category,
  code,
  error,
});

export const showRequestWorkflowStatus = (category, code, result) => ({
  type: actions.SHOW_REQUEST_WORKFLOW_STATUS,
  category,
  code,
  result,
});

export const showRequestWorkflowStatusError = (category, code, error) => ({
  type: actions.SHOW_REQUEST_WORKFLOW_STATUS_ERROR,
  category,
  code,
  error,
});

export const showRequestSourceError = (category, code, error) => ({
  type: actions.SHOW_REQUEST_SOURCE_ERROR,
  category,
  code,
  error,
});

export const closeRequests = ({ category }) => ({
  type: actions.CLOSE_REQUESTS,
  category,
});

export const closeRequest = ({ category, code }) => ({
  type: actions.CLOSE_REQUEST,
  category,
  code,
});

export const approveRequest = (items, reason) => ({
  type: actions.APPROVE_REQUEST,
  items,
  reason,
});

export const approveRequestSuccess = (items) => ({
  type: actions.APPROVE_REQUEST_SUCCESS,
  items,
});

export const approveRequestError = (items) => ({
  type: actions.APPROVE_REQUEST_ERROR,
  items,
});

export const denyRequest = (items, reason) => ({
  type: actions.DENY_REQUEST,
  items,
  reason,
});

export const denyRequestSuccess = (items) => ({
  type: actions.DENY_REQUEST_SUCCESS,
  items,
});

export const denyRequestError = (items) => ({
  type: actions.DENY_REQUEST_ERROR,
  items,
});

export const showDeleteRequest = (category, code) => ({
  type: actions.SHOW_DELETE_REQUEST,
  category,
  code,
});

export const deleteRequests = ({ items }) => ({
  type: actions.DELETE_REQUESTS,
  items,
});

export const showArchiveRequest = (category, code) => ({
  type: actions.SHOW_ARCHIVE_REQUEST,
  category,
  code,
});

export const hideArchiveRequest = () => ({
  type: actions.HIDE_ARCHIVE_REQUEST,
});

export const archiveRequests = (items, reason) => ({
  type: actions.ARCHIVE_REQUESTS,
  items,
  reason,
});

export const destroyRequests = (items, isArchival, silent) => ({
  type: actions.DESTROY_REQUESTS,
  isArchival,
  items,
  silent,
});

export const destroyRequestsError = (items, isArchival) => ({
  type: actions.DESTROY_REQUESTS_ERROR,
  items,
  isArchival,
});

export const hideDeleteRequest = () => ({
  type: actions.HIDE_DELETE_REQUEST,
});

export const showTransferRequest = (category, code) => ({
  type: actions.SHOW_TRANSFER_REQUEST,
  category,
  code,
});

export const hideTransferRequest = () => ({
  type: actions.HIDE_TRANSFER_REQUEST,
});

export const transferRequest = (items, automatic) => ({
  type: actions.TRANSFER_REQUEST,
  items,
  automatic,
});

export const transferRequestSuccess = (items, automatic) => ({
  type: actions.TRANSFER_REQUEST_SUCCESS,
  items,
  automatic,
});

export const transferRequestError = (items, automatic) => ({
  type: actions.TRANSFER_REQUEST_ERROR,
  items,
  automatic,
});

export const toggleRequestsPresentation = (category, display) => ({
  type: actions.TOGGLE_REQUESTS_PRESENTATION,
  category,
  display,
});

export const showWorkflowForRequest = (category, code, requestCode, result) => ({
  type: actions.SHOW_WORKFLOW_FOR_REQUEST,
  category,
  code,
  requestCode,
  result,
});

export const showWorkflowRequestError = (category, code, requestCode, error) => ({
  type: actions.SHOW_WORKFLOW_REQUEST_ERROR,
  category,
  code,
  requestCode,
  error,
});
